//Feature constants.

export const ACCOUNT_MANAGEMENT = '/Account Management/';

//Opportunities
export const CREATE_OPPORTUNITIES = '/Opportunities/Create/';
export const DELETE_OPPORTUNITIES = '/Opportunities/Delete/';
export const UPDATE_OPPORTUNITIES = '/Opportunities/Edit/';
export const VIEW_OPPORTUNITIES = '/Opportunities/';
//Clients
export const VIEW_CLIENTS = '/Account Management/Clients/';
export const CREATE_CLIENTS = '/Account Management/Clients/Create/';
export const EDIT_CLIENTS = '/Account Management/Clients/Edit/';
export const DELETE_CLIENTS = '/Account Management/Clients/Delete/';
export const UPLOAD_CLIENTS = '/Account Management/Clients/Upload/';
export const ASSIGN_CLIENTS = '/Account Management/Clients/Assign/';
export const MANAGE_ALL_CLIENTS = '/Account Management/Clients/Manage All/';

//CRM Settings
export const VIEW_CRM_SETTINGS = '/Account Management/Clients/Settings/';
export const UPDATE_FIELD_SETTINGS = '/Account Management/Clients/Settings/Custom Fields/';
export const UPDATE_TYPE_SETTINGS = '/Account Management/Clients/Settings/Custom Types/';
export const UPDATE_PIPELINE_SETTINGS = '/Account Management/Clients/Settings/Pipeline Builder/';

//Canvassing
export const VIEW_CANVASSING = '/Canvassing/';
export const VIEW_CANVASSING_MARKERS = '/Canvassing/Markers/View/';
export const CREATE_CANVASSING_MARKERS = '/Canvassing/Markers/Create/';
export const DELETE_CANVASSING_MARKERS = '/Canvassing/Markers/Delete/';
export const MANAGE_CANVASSING_MARKERS = '/Canvassing/Markers/Manage/';

//Canvassing Regions
export const VIEW_CANVASSING_REGIONS = '/Canvassing/Regions/';
export const CREATE_CANVASSING_REGIONS = '/Canvassing/Regions/Create/';
export const UPDATE_CANVASSING_REGIONS = '/Canvassing/Regions/Update/';
export const DELETE_CANVASSING_REGIONS = '/Canvassing/Regions/Delete/';

//Users
export const VIEW_USERS = '/Account Management/Users/'
export const ADMINISTRATE_USERS = '/Account Management/Users/Administrate/';
export const CREATE_USERS = '/Account Management/Users/Create/';
export const EDIT_USERS = '/Account Management/Users/Edit/User Details/';
export const DELETE_USERS = '/Account Management/Users/Delete/';
export const ASSIGN_USERS = '/Account Management/Users/Assign/';

//Roles
export const CREATE_ROLES = '/Account Management/Roles/Create/';
export const EDIT_ROLES = '/Account Management/Roles/Edit/';
export const DELETE_ROLES = '/Account Management/Roles/Delete/';
export const ASSIGN_ROLES = '/Account Management/Roles/Assign/';

//Account Billing Management
export const PURCHASE_PLANS = '/Account Management/Purchases/Plans/';
export const PURCHASE_MAPS = '/Account Management/Purchases/Maps/';
export const BILLING = '/Account Management/Billing/';

//Blog
export const VIEW_BLOG_EDITOR = '/Post/';
export const CREATE_POSTS = '/Post/Create/';
export const EDIT_POSTS = '/Post/Edit/';
export const DELETE_POSTS = '/Post/Delete/';

//Maps
export const SEARCH_MAPS = '/Maps/Search/';
export const EDIT_MAPS = '/Maps/Edit/';
export const VIEW_MAPS = '/Maps/View/';
export const CREATE_MAPS = '/Maps/Create/';
export const DELETE_MAPS = '/Maps/Delete/';

//Data
export const DOWNLOAD_DATA_LIST = '/Account Management/Data Services/Unlimited List Downloads/';

//Permissions
export const VIEW_PERMISSIONS = '/Permissions/';
export const CREATE_PERMISSIONS = '/Permissions/Create/';
export const EDIT_PERMISSIONS = '/Permissions/Edit/';
export const DELETE_PERMISSIONS = '/Permissions/Delete/';

//Notifications
export const VIEW_NOTIFICATIONS = '/Notification/';
export const CREATE_NOTIFICATIONS = '/Notification/Create/';
export const EDIT_NOTIFICATIONS = '/Notification/Edit/';
export const DELETE_NOTIFICATIONS = '/Notification/Delete/';

//Integrations
export const INTEGRATIONS = '/Integrations/';
export const INTEGRATIONS_JOBNIMBUS = '/Integrations/Job Nimbus/';

//Reports
export const VIEW_REPORTS = '/Reports/';
export const VIEW_CANVASSING_REPORT = '/Reports/Canvassing/';

//Pages
export const MANAGE_PAGE_TEMPLATES = '/Pages/Manage Templates/';
export const MANAGE_PAGE_CONTENT = '/Pages/Manage Content/';

//Live Weather Center
export const ADMINISTRATE_LIVE_WEATHER_CENTER_CHAT = '/Live Weather Center/Administrate Chat/';

// Plans
export const PLANS = '/Plans/';
export const CREATE_PLANS = '/Plans/Create/';
export const UPDATE_PLANS = '/Plans/Update/';
export const VIEW_PLANS = '/Plans/View/';
export const DELETE_PLANS = '/Plans/Delete/';

// Error Logs
export const ERROR_LOGS = '/Error Logs/';
export const VIEW_ERROR_LOGS = '/Error Logs/View/';



// WEBPACK FOOTER //
// ./src/common/permissions.js